// Module
var code = "<div class=\"trio-color-gradient\">\r\n    {{#.value}}\r\n        <div class=\"trio-color-gradient-line\" style=\"background: linear-gradient(to right, {{.Color1}}, {{.Color2}}, {{.Color3}});\"></div>\r\n    {{/}}\r\n</div>";
// Exports
export default code;